import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./admin.css";

const links = [
  { to: "/admin", end: true, ico: "▪", label: "Dashboard" },
  { to: "/admin/reports", ico: "▤", label: "Reports" },
  { to: "/admin/jobs", ico: "▧", label: "Job Openings" },
  { to: "/admin/applications", ico: "▦", label: "Applications" },
  { to: "/admin/catalogue", ico: "▩", label: "Product Catalogue" },
  { to: "/admin/contact", ico: "▨", label: "Contact Info" },
];

const AdminLayout = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="admin-root">
      <div className="admin-shell">
        <aside className="admin-sidebar">
          <div className="admin-brand">Softwood<span>.</span></div>
          <div className="admin-brand-sub">Content Admin</div>

          <nav className="admin-nav">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end}>
                <span className="nav-ico">{l.ico}</span>
                <span>{l.label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="admin-user">
            <div className="email">{currentUser?.email}</div>
            <button className="btn btn-ghost btn-block" onClick={handleLogout}>
              Sign Out
            </button>
          </div>
        </aside>

        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
